import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from '../lib/query-client';
import { FilterProvider } from '../context/FilterContext';
import { AuthProvider } from '../contexts/AuthContext';

export const Providers = ({ children }) => {
  return (
    <QueryClientProvider client={queryClient}>
      <FilterProvider>
        <BrowserRouter>
          <AuthProvider>
            {children}
          </AuthProvider>
        </BrowserRouter>
      </FilterProvider>
    </QueryClientProvider>
  );
};
